import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandPinterest, IconBrandTiktok, IconBrandX, IconBrandYoutube, IconWorld, type TablerIcon } from '@tabler/icons-react';

export interface ParsedSocialLink {
  url: string;
  label: string;
  icon: TablerIcon;
}

interface PlatformConfig {
  pattern: RegExp;
  label: string;
  icon: TablerIcon;
}

const PLATFORM_CONFIGS: PlatformConfig[] = [
  { pattern: /facebook\.com/i, label: 'Facebook', icon: IconBrandFacebook },
  { pattern: /instagram\.com/i, label: 'Instagram', icon: IconBrandInstagram },
  { pattern: /youtube\.com/i, label: 'YouTube', icon: IconBrandYoutube },
  { pattern: /pinterest\.com/i, label: 'Pinterest', icon: IconBrandPinterest },
  { pattern: /(twitter\.com|x\.com)/i, label: 'X (Twitter)', icon: IconBrandX },
  { pattern: /tiktok\.com/i, label: 'TikTok', icon: IconBrandTiktok },
  { pattern: /linkedin\.com/i, label: 'LinkedIn', icon: IconBrandLinkedin },
];

/**
 * Parses a social media URL and returns the appropriate icon and label
 */
export function parseSocialLink(url: string): ParsedSocialLink {
  for (const config of PLATFORM_CONFIGS) {
    if (config.pattern.test(url)) {
      return {
        url,
        label: config.label,
        icon: config.icon,
      };
    }
  }

  // Default fallback for unknown URLs
  return {
    url,
    label: 'Website',
    icon: IconWorld,
  };
}

/**
 * Parses an array of social link URLs
 */
export function parseSocialLinks(urls: string[]): ParsedSocialLink[] {
  return urls.map(parseSocialLink);
}
